var lastScrollTop = 0,
  lastScrollDir = 0,
  upgradeLoading = !1,
  triggerCustomCartDataLoading = !1;
try {
    (localStorage.getItem("admin-release") == "admin-release" || window.location.href.indexOf("myshopify") > -1 || window.location.href.indexOf("oseid") > -1 || window.location.href.indexOf("admin-release") > -1) &&
      (localStorage.setItem("admin-release", "admin-release"), document.getElementById("fs-release-overlay").remove(), setTimeout(() => UnlockScroll(), 500));
} catch {
  console.error("release disable fail");
}
document.addEventListener("rebuy:smartcart.init", (event) => {
  ConfigureCartCount();
}),
  document.addEventListener("rebuy:smartcart.show", (event) => {
    ConfigureCartCount();
  }),
  document.addEventListener("rebuy:cart.change", (event) => {
    ConfigureCartCount();
  }),
  setTimeout(() => {
    window.location.href.indexOf("admin=1") > -1 && ($("body").addClass("admin-view"), $("#header-countdown").show());
  }, 1e3);
function ConfigureCartCount() {
  var itemCount = Rebuy.Cart.itemCount(),
    lineCount = Rebuy.Cart.lineCount();
  $("#cart-count-mb").text(itemCount),
    $("#cart-count-dt").text(itemCount),
    setTimeout(() => {
      $("#cart-count-mb").show(), $("#cart-count-dt").show();
    }, 100);
}
/*
 * Removed 5 Sep 2026: legacy Arrae / Yotpo star-rating block.
 *
 * Inherited from the Arrae theme this build was based on. It fetched review data from
 * https://arrae-yotpo-4c7d6545d621.herokuapp.com on every page load and re-ran on a
 * 10-second setInterval, but it rendered nothing: no [data-stars] or *_rating_stars
 * markup exists anywhere in the theme, the jQuery starRating plugin it called was never
 * loaded, and a search of all 424 theme files found no reference to any of its functions.
 * Reviews on this store are served by Judge.me.
 *
 * Removed: the .f_filter click handler, refreshStars and its setTimeout/setInterval,
 * rateReview, getAllReviews (and its call at load), CacheAllResults, registerStars,
 * renderRegisteredStars, RenderStarRating, getStarRating, and the window.starRatings /
 * reviewsFetched / review_callbacks globals.
 */
function CustomReset() {
  document.querySelector(".cart-button-checkout-text")?.classList.remove("hide"), document.querySelector(".cart-button-checkout-spinner")?.classList.add("hide");
}
function CustomListen() {
  document.querySelectorAll("button.secondary.qty-plus").forEach((item) => {
    item.addEventListener("click", function (e) {
      document.querySelectorAll(".quantity-controls button.qty-plus:not(.secondary)").forEach((_i) => {
        _i.click();
      });
    });
  }),
    document.querySelectorAll("button.secondary.qty-minus").forEach((item) => {
      item.addEventListener("click", function (e) {
        document.querySelectorAll(".quantity-controls button.qty-minus:not(.secondary)").forEach((_i) => {
          _i.click();
        });
      });
    });
}
function CustomQuantityChanged(variant_id, e, main_price, var_price) {
  (window.product.CompareAtPrice = `${getCurrencySymbol()}${var_price / 100}`), main_price == var_price && (window.product.CompareAtPrice = `${getCurrencySymbol()}0.00`);
  for (var x = document.getElementsByClassName(e.target.className), i = 0; i < x.length; i++) x[i].checked = !0;
  (window.product.Price = `${getCurrencySymbol()}${main_price / 100}`), custom_variant_change(variant_id);
}
function recalcPrice(newVal, variant_id) {
  if (!(typeof window.product > "u" || window.product == null)) {
    for (var bp = parseFloat(window.product.Price.replace(getCurrencySymbol(), "")), newPrice = bp * newVal, quant = document.getElementsByClassName("quantity-selector"), i = 0; i < quant.length; i++) quant[i].value = newVal;
    for (var ptu = document.getElementsByClassName("update_price_field"), i = 0; i < ptu.length; i++) ptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}">${getCurrencySymbol()}${newPrice.toFixed(2)}</span>`;
    for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++) cptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}"></span>`;
    if (window.product.CompareAtPrice == "\xA30.00") for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++) cptu[i].innerHTML = '<span class="money"></span>';
    else
      for (var compAtPrice = parseFloat(window.product.CompareAtPrice.replace(getCurrencySymbol(), "")), newCompPrice = compAtPrice * newVal, cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++)
        cptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}">${getCurrencySymbol()}${newCompPrice.toFixed(2)}</span>`;
  }
}
function DisplayPrice(newPrice, newCompPrice, quantity = 1, product_id) {
  newPrice *= quantity;
  for (var igMultiplier = newPrice / newCompPrice, ptu = document.getElementsByClassName("update_price_field"), i = 0; i < ptu.length; i++)
    ptu[i].innerHTML = `<span class="money igPrice" data-product-id="${product_id}" ${igMultiplier != NaN ? "data-price-multiplier='" + igMultiplier * quantity + "'" : ""}>${getCurrencySymbol()}${newPrice.toFixed(2)}</span>`;
  if (newCompPrice == null || newCompPrice.toString().endsWith("0.00") || newCompPrice.toString() == newPrice.toString())
    for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++) cptu[i].innerHTML = `<span class="money" data-product-id="${product_id}"></span>`;
  else
    for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++)
      cptu[i].innerHTML = `<span class="money igPrice" data-product-id="${product_id}" data-price-multiplier="${quantity}">${getCurrencySymbol()}${newCompPrice.toFixed(2)}</span>`;
}
function getCurrencySymbol() {
  const locale = window.Shopify.locale,
    currency = window.Shopify.currency.active;
  return (0).toLocaleString(locale, { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, "").trim();
}
function custom_variant_change(variant_id) {
  var qtyInput = document.getElementById("quantity"),
    val = parseInt(qtyInput.value.toString(), 10),
    variantInput = document.getElementById("product_id");
  (variantInput.value = variant_id), recalcPrice(val, variant_id);
}
/* 6 Sep 2026: ConfigureRecharge() and ConfigureSubAndSave() removed with their functions.
   CEAN has no selling plans (sellingPlanGroups = []), Recharge is not installed, and the
   markup they targeted (.selected_selling_plan / .selling_plan_options) exists nowhere in
   this theme. Inherited from the Arrae theme this build started from. */
CustomListen(), CustomReset();
function ShowLoading() {
  (document.getElementById("loadingOverlay").style.display = "flex"), LockScroll();
}
function HideLoading() {
  (document.getElementById("loadingOverlay").style.display = "none"), UnlockScroll();
}
function LockedScroll() {
  return $("html").hasClass("whitebox-open");
}
function LockScroll() {
  var y = -scrollY;
  $("html").addClass("whitebox-open"), $(".whitebox-open body").css("top", y);
}
function UnlockScroll() {
  var y = Number.parseFloat($(".whitebox-open body").css("top"));
  (y = y * -1),
    $(".whitebox-open body").css("top", null),
    $("html").removeClass("whitebox-open"),
    window.scrollTo({ top: y, left: 0, behavior: "instant" }),
    setTimeout(() => {
      window.scrollTo({ top: y, left: 0, behavior: "instant" });
    }, 10);
}
/**
 * Predictive Search – Tab switcher
 * Tabs:  #search-products    → .search-products
 *        #search-collections → .search-collections
 *        #search-pages       → .search-pages
 */

document.addEventListener('DOMContentLoaded', function () {
  const TAB_MAP = [
    { navId: 'search-products',    panelClass: 'search-products' },
    { navId: 'search-collections', panelClass: 'search-collections' },
    { navId: 'search-pages',       panelClass: 'search-pages' },
  ];

  function activate(wrapper, activeNavId) {
    TAB_MAP.forEach(({ navId, panelClass }) => {
      const navItem = wrapper.querySelector('#' + navId);
      const panel   = wrapper.querySelector('.' + panelClass);
      const isActive = navId === activeNavId;
      if (navItem) navItem.classList.toggle('is-active', isActive);
      if (panel)   panel.style.display = isActive ? '' : 'none';
    });
  }

  function initPSTabs() {
    const wrapper = document.getElementById('predictive-search-results');
    if (!wrapper) return;

    // Find the first nav item that actually exists (Liquid only renders tabs with results)
    let defaultNavId = null;
    for (const { navId } of TAB_MAP) {
      if (wrapper.querySelector('#' + navId)) {
        defaultNavId = navId;
        break;
      }
    }
    if (!defaultNavId) return;

    // Set initial state: show first tab, hide the rest
    activate(wrapper, defaultNavId);

    // Bind clicks — clone each item to clear any stale listeners from prior renders
    TAB_MAP.forEach(({ navId }) => {
      const navItem = wrapper.querySelector('#' + navId);
      if (!navItem) return;

      const fresh = navItem.cloneNode(true);
      navItem.parentNode.replaceChild(fresh, navItem);

      fresh.addEventListener('mousedown', function (e) {
        e.preventDefault(); // keep focus in search input
        activate(wrapper, fresh.id);
      });
    });
  }

  initPSTabs();
  window.initPSTabs = initPSTabs;

  // Re-init whenever Shopify re-injects the results HTML on each keystroke
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          (node.id === 'predictive-search-results' ||
            node.querySelector?.('#predictive-search-results'))
        ) {
          initPSTabs();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
